module.exports = __webpack_public_path__ + "img/theme.5212777f.svg";